module.exports = __webpack_public_path__ + "static/media/plant-unhappy.9521e492.svg";